import { createStore, applyMiddleware } from 'redux'
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant'
import { composeWithDevTools } from '@redux-devtools/extension'
import rootReducer from './index'
import thunkMiddleWare from 'redux-thunk'

export const middleware = []

if (process.env.NODE_ENV !== 'production') {
  middleware.push(reduxImmutableStateInvariant())
}
middleware.push(thunkMiddleWare)
export default function configureStore() {
  return createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(...middleware)),
  )
}
